import React from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';
import Link from '../../utils/link';

import Typography from '../../atoms/typography';

const Brand = styled(Typography)`
  color: ${(props) => (props.theme.color.brand)};
  display: inline-block;
  font-style: italic;
  line-height: 2rem;
  text-decoration: none;
`;

const Product = styled(Typography)`
  color: ${(props) => (props.theme.color.brand)};
  display: inline-block;
  line-height: 1.5;
  text-decoration: none;
`;

const Title = styled.div`
  display: flex;
  flex-direction: column;

  > a {
    align-self: flex-start;
  }
`;

const CartProductTitle = (props) => (
  <Title data-test-id="order-product-title" className={props.className}>
    {
      props.brand.name && props.brand.permalink && (
        <Link href={props.brand.permalink} passHref>
          <Brand element="a" like="paragraph-3">{props.brand.name}</Brand>
        </Link>
      )
    }

    <Link href={props.product.permalink} passHref>
      <Product element="a" like="paragraph-3">{props.product.name}</Product>
    </Link>
  </Title>
);

CartProductTitle.defaultProps = {
  brand: false,
  className: ''
};

CartProductTitle.propTypes = {
  className: PropTypes.string,
  brand: PropTypes.shape({
    name: PropTypes.string,
    permalink: PropTypes.string
  }),
  product: PropTypes.shape({
    name: PropTypes.string,
    permalink: PropTypes.string
  }).isRequired
};

export default CartProductTitle;
